<template>
   <div id="rolewxpart">
       <div class="tos">
          <el-form :inline="true" :model="queryRolePageDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="角色昵称：">
                <el-input v-model="queryRolePageDto.name"></el-input>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="right-item"  type="primary" @click=newoks()>添加</el-button>
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="roleName"
                label="角色名称"
                >
                <template slot-scope="{row:{ roleName }}">
                {{ roleName|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="roleCode"
                label="角色编码"
                >
                <template slot-scope="{row:{ roleCode }}">
                {{ roleCode|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                      <el-button @click="handleClick(scope.row)" type="success"  size="small">编辑</el-button>
                      <el-button type="danger" size="small" @click="dels(scope.row)" >删除</el-button>
                      <el-button type="primary" size="small" @click="intos(scope.row)">权限设置</el-button>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryRolePageDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="queryRolePageDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
       <!-- 添加角色-->
       <el-dialog title="添加" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="roleDto" :model="roleDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="角色昵称：" prop="roleName">
                    <el-input v-model="roleDto.roleName" placeholder="请输入..."></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('roleDto',roleDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="修改" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="roleDto" :model="roleDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="角色昵称：" prop="roleName">
                    <el-input v-model="roleDto.roleName" placeholder="请输入..."></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="xiugoks('roleDto',roleDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 角色权限 -->
       <el-dialog title="功能分配" :visible.sync="RolePermission" width="30%">
            <el-tree 
               :data="gnvalue" 
               show-checkbox 
               :props="defaultProps" 
               node-key="id" 
               ref="tree" 
               highlight-current
               @node-click="handleNodeClick" 
               @check-change="handleCheckChange">
            </el-tree>
        <div class="btns">
            <el-button  type="danger" @click="quxiao()">取消</el-button>
            <el-button type="warning" @click="qingkong()" >清空</el-button>
            <el-button :disabled="disabled" type="primary" @click="queding()">确定</el-button>
        </div>
        </el-dialog>
   </div>
   </template>
   <script>
      export default {
      name:'rolewxpart',
      data(){
       return{
          queryRolePageDto:{
             pageNum:1,
             pageSize:10,
             name:null,
          },
          tableData: [],
          totals:10,
          increase:false,
          dialogFormVisible:false,
          RolePermission:false,
          roleDto:{
            roleName:'',
         },
         zcrules: {
            roleName: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
         },
         roleIdID:'',
         disabled:false,
         gnvalue: [],
         defaultProps: {
            children: 'resourceVoList',
            label: 'resourceName',
            value:"id"
         },
       }
      },
      created(){
       this.getlist(this.queryRolePageDto)
      },
      mounted(){
      },
      methods:{
       getlist(queryRolePageDto) {
          this.$api.hqjslbfypage(queryRolePageDto)
          .then((res) => {
                this.tableData = res.data.data.records
                this.totals = res.data.data.total
          })
       },
       sjhsearchFor(type){
         this.getlist(this.queryRolePageDto)
       },
       submitForm(formName,data) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.tjjsxxadd(data).then((res) => {
                    if (res.data.code == 200) {
                        this.increase = false
                        this.queryRolePageDto={
                              pageNum:1,
                              pageSize:10,
                              name:null,
                           },
                           this.getlist(this.queryRolePageDto)
                        this.$message.success(res.data.message)
                    } else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                        return
                    }
                })
            } else {
                return false;
            }
            });
        },
        xiugoks(roleDto,data) {
            this.$refs[roleDto].validate((valid) => {
            if (valid) {
                this.$api.xgjsxxupdate(data).then((res)=>{
                if(res.data.code==200){
                  this.getlist(this.queryRolePageDto)
                  this.roleDto={
                     roleName:'',
                  },
                  this.dialogFormVisible = false;
                  this.$message.success(res.data.message)
                }else{
                  this.$message.error(res.data.message)
                }
                })
            } else {
                return false;
            }
            });
        },
      handleClick(row) {
         this.dialogFormVisible = true;
         this.$api.hqjsxqdetail({
            roleId:row.roleId
         }).then((res)=>{
            if (res.data.code == 200) {
                  this.roleDto = res.data.data
               } else {
                  this.$message.error(res.data.message)
               }
            
         })
      },
      dels(e) {
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.Deledelete({
            roleId:e.roleId
          }).then((res) => {
              if (res.data.code == 200) {
                  this.getlist(this.queryRolePageDto)
                  this.$message.success(res.data.message)
               } else {
                  this.$message.error(res.data.message)
               }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
       // 获取权限
       intos(e) {
            this.roleIdID = e.roleId
            this.RolePermission = true
            this.$api.fdqyhresource().then((res) => {
                this.gnvalue = res.data.data
                let havekey = []
                    res.data.data.forEach(first => {
                            if (first.resourceVoList.length == 0) {
                                havekey.push(first)
                            } else {
                                first.resourceVoList.forEach(twos => {
                                    if (twos.resourceVoList== null) {
                                        havekey.push(twos)
                                    } 
                                })
                            }
                        });
                    this.$refs.tree.setCheckedNodes(havekey);
                    if(havekey.length==0){
                        this.disabled=true
                    }else{
                        this.disabled=false
                    }
            })
            this.$api.getBindMenu({
                    roleId:e.roleId
                }).then((res)=>{
                    let datalist = []
                    res.data.data.forEach(first => {
                        if (first.resourceVoList.length == 0) {
                            datalist.push(first.id)
                        } else {
                            first.resourceVoList.forEach(twos => {
                                if (twos.resourceVoList == null) {
                                    datalist.push(twos.id)
                                } 
                            })
                        }
                    });
                    this.$refs.tree.setCheckedKeys(datalist);
               })
        },
      handleNodeClick(data) {
      },
      handleCheckChange(checked, node) {
         if(this.$refs.tree.getHalfCheckedKeys().concat(this.$refs.tree.getCheckedKeys()).length==0){
               this.disabled=true
         }else{
               this.disabled=false
         }
         // this.updateParentCheckStatus(node);
      },
      queding(){
            const adddata = this.$refs.tree.getHalfCheckedKeys().concat(this.$refs.tree.getCheckedKeys())
            this.$api.addMenuShip({
                resourceList:adddata,
                roleId:this.roleIdID
            }).then((res)=>{
                if(res.data.code==200){
                  this.$message.success(res.data.message)
                  this.RolePermission = false
                }else{
                  this.$message.error(res.data.message)
                }
            })
        },
      qingkong(){
         this.$confirm('是否确定清空, 是否继续?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               this.$api.deleteMenuShip({
                  roleId:this.roleIdID
               }).then((res)=>{
                  if(res.data.code==200){
                     this.$message.success(res.data.message)
                     this.RolePermission=false
                  }else{
                     this.$message.error(res.data.message)
                  }
               })
            }).catch(() => {
               this.$message({
               type: 'info',
               message: '已取消'
               });          
            });
         
      },
      quxiao() {
        this.RolePermission=false
      },
      newoks() {
         this.increase = true
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.roleDto={
            roleName:'',
         }
      },
       handleCurrentChange(val) {
           this.queryRolePageDto.pageNum = val
           this.getlist(this.queryRolePageDto)
         },
         handleSizeChange(val) {
           this.queryRolePageDto.pageSize = val
           this.getlist(this.queryRolePageDto)
         },
      }
      }
   </script>
   <style scoped>
#rolewxpart {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
       /* background: pink; */
       display: flex;
       width: 40%;
       align-items: center;
       justify-content: space-around;
       margin: auto;
       margin-top: 30px;
   }
.zcyhtk /deep/ .el-form-item__label {
  width: 100px !important;
}
.zcyhtk /deep/ .el-form-item__content {
  margin-left: 100px !important;
}
.btns{
    width: 80%;
    /* border: 1px solid red; */
    margin: auto;
    margin-top: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    /* text-align: center; */
}
   </style>


// WEBPACK FOOTER //
// src/components/xtglwxpart/rolewxpart.vue